import React from 'react'
import Tab from '../../components/UI/TabbedPanel/TabbedPanel'

        const Contents = (props) => {
    return(
            <div className="row justify-content-center">
                <Tab />
            </div>
            )
}

export default Contents